import React from "react"

export const isBrowser = typeof window !== `undefined`

// Application Context
const initialAppContextValue = {
  isAuthenticated: false, // updated on each paged load
}
export const AppContext = React.createContext(initialAppContextValue)
